import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import SelectorDays from "../content/SelectorDays.jsx";
import { Functions } from "../../../helpers/Functions.jsx";
import { tr } from "date-fns/locale";

const VentasModal = ({ show, onClose, onSave, showCreate, title, descuentoVentas, initDataVentas }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, setValue : setValueModal, reset:resetModal, getValues: getValuesModal, trigger:triggerModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [selectedDays, setSelectedDays] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [detalles, setDetalles] = useState(CONFIGURACIONES.INIT.ARRAY);

    const onAgregarItem = (form) => {
        const {totalVentas, ...form2} = form;
        form2['id'] = Functions().generarNumeroUnico(detalles);
        form2['detalleDias'] = selectedDays.join(', ');
        setDetalles([...detalles, form2]);
        setSelectedDays(CONFIGURACIONES.INIT.ARRAY);
        resetModal();
        setValueModal('descuento', isNaN(descuentoVentas) ? '' : descuentoVentas.toFixed(2));
    };

    useEffect(() => {
        resetModal();
        setSelectedDays(CONFIGURACIONES.INIT.ARRAY);
        setValueModal('descuento', isNaN(descuentoVentas) ? '' : descuentoVentas.toFixed(2));
        if (initDataVentas !== CONFIGURACIONES.INIT.NULL) {
            setValueModal('totalVentas', initDataVentas.total);
            setDetalles(initDataVentas.detalles);
        }
    }, [initDataVentas]);

    useEffect(() => { 
        setValueModal('descuento', isNaN(descuentoVentas) ? '' : descuentoVentas.toFixed(2));
    }, [descuentoVentas]);

    useMemo(() => {
        let total = 0;
        detalles.forEach((item) => {
            total += parseFloat(item.totalSemana);
        });
        setValueModal('totalVentas', isNaN(total) ? '' : total.toFixed(2));
        return isNaN(total) ? '' : total.toFixed(2); 
    }, [detalles]);

    useEffect(() => {
        setValueModal('dias', selectedDays.length);
        triggerModal('dias');
        let diarioValue = getValuesModal('diario') ? parseFloat( getValuesModal('diario') ) : 0;
        let diasCount = getValuesModal('dias') ? parseInt( getValuesModal('dias') ) : 0;
        let totalSemanaValue = diarioValue * diasCount;
        setValueModal('totalSemana', isNaN(totalSemanaValue) ? '' : totalSemanaValue.toFixed(2));
        triggerModal('totalSemana');
        let descuentoValue = getValuesModal('descuento') ? parseFloat( getValuesModal('descuento') ) : 0;
        let cuotaMaximaValue = (getValuesModal('totalSemana')?parseFloat(getValuesModal('totalSemana')): 0) * (descuentoValue / 100);
        setValueModal('cuotaMaxima', isNaN(cuotaMaximaValue) ? '' : cuotaMaximaValue.toFixed(2));
        triggerModal('cuotaMaxima');
    }, [selectedDays]);

    const saveData = () => {
        let data = {
            'total': getValuesModal('totalVentas'),
            'detalles': detalles
        }

        onSave(data);
    };
    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onAgregarItem)} autoComplete="off" 
                    style={{ display: 'flex', flexDirection: 'column', minHeight: 'inherit' }} >
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body" style={{ overflowY: 'auto', flexGrow: 1 }}>  
                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                                <SelectorDays selectedDays={selectedDays} setSelectedDays={setSelectedDays} />
                            </div>
                        </div>

                        <div className="row mt-md-2">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="diasVenta" className="control-label col-form-label">Días Venta <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("diasVenta", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                        })} className="form-control" id="diasVenta"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            CONFIGURACIONES.INIT.LIST.DIAS_VENTA.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.diasVenta && errorsModal.diasVenta.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="diario" className="control-label col-form-label">Diario <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="diario"
                                        id="diario"
                                        {...registerModal("diario", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                let diarioValue = e.target.value ? parseFloat(e.target.value) : 0;
                                                let diasCount = getValuesModal('dias') ? parseInt(getValuesModal('dias')) : 0;

                                                console.log(`diario: ${diarioValue}, dias: ${diasCount}`);
                                                
                                                let totalSemanaValue = diarioValue * diasCount;
                                                setValueModal('totalSemana', isNaN(totalSemanaValue) ? '' : totalSemanaValue.toFixed(2));
                                                triggerModal('totalSemana');
                                                let descuentoValue = getValuesModal('descuento') ? parseFloat( getValuesModal('descuento') ) : 0;
                                                let cuotaMaximaValue = (getValuesModal('totalSemana')?parseFloat(getValuesModal('totalSemana')): 0) * (descuentoValue / 100);
                                                setValueModal('cuotaMaxima', isNaN(cuotaMaximaValue) ? '' : cuotaMaximaValue.toFixed(2));
                                                triggerModal('cuotaMaxima');
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.diario && errorsModal.diario.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="dias" className="control-label col-form-label">Días <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="dias"
                                        id="dias"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        {...registerModal("dias", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER_DAYS,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.dias && errorsModal.dias.message }</small>
                                </div>
                            </div>
                            
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="totalSemana" className="control-label col-form-label">Total Semana <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="totalSemana"
                                        id="totalSemana"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        {...registerModal("totalSemana", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.totalSemana && errorsModal.totalSemana.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="descuento" className="control-label col-form-label">Descuento <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="descuento"
                                            id="descuento"
                                            readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                            {...registerModal("descuento", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text">%</span>
                                        </div>
                                    </div>
                                    <small className="invalid-feedback"> { errorsModal.descuento && errorsModal.descuento.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="cuotaMaxima" className="control-label col-form-label">Cuota Máxima <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="cuotaMaxima"
                                        id="cuotaMaxima"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        {...registerModal("cuotaMaxima", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.cuotaMaxima && errorsModal.cuotaMaxima.message }</small>
                                </div>
                            </div>
                            
                            <div className="col-sm-12 col-md-6">
                                <div className="form-group">
                                    <label htmlFor="descripcion" className="control-label col-form-label">Descripción <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="descripcion"
                                        id="descripcion"
                                        {...registerModal("descripcion", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.descripcion && errorsModal.descripcion.message }</small>
                                </div>
                            </div>


                        </div>
                        <div className="row my-2">
                            <div className="col-sm-12 col-md-3">
                                <WaveButton className="btn btn-sm btn-outline-info wave-effect" type="submit">
                                    <i className="mdi mdi-plus"></i> Agregar
                                </WaveButton>
                            </div>
                        </div>

                        {/* 📊 Tabla */}
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                            <table className="table table-sm table-hover compact-table align-middle text-wrap">
                                <thead className="bg-success text-white sticky-top" style={{ top: 0 }}>
                                <tr>
                                    <th>Descripción</th>
                                    <th>Días Venta</th>
                                    <th>Diario</th>
                                    <th>Días</th>
                                    <th>Detalle días</th>
                                    <th>Total Semana</th>
                                    <th>Descuento</th>
                                    <th>Cuota Máxima</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {detalles.length > 0 ? (
                                    detalles.map((item) => (
                                        <tr key={item.id}>
                                            <td className="text-wrap">{item.descripcion}</td>
                                            <td className="text-wrap">{item.diasVenta ? item.diasVenta.replace(/_/g, ' '):item.diasVenta}</td>
                                            <td className="text-wrap">{item.diario}</td>
                                            <td className="text-wrap">{item.dias}</td>
                                            <td className="text-wrap">{item.detalleDias}</td>
                                            <td className="text-wrap">{item.totalSemana}</td>  
                                            <td className="text-wrap">{item.descuento}</td>
                                            <td className="text-wrap">{item.cuotaMaxima}</td>
                                            <td>
                                                <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => {
                                                    setDetalles(detalles.filter((detalle) => detalle.id !== item.id));
                                                }}>
                                                    <i className="mdi mdi-delete"></i>
                                                </WaveButton>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center text-muted">
                                            <span className="text-danger">No se encontraron resultados</span>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-2">
                                <div className="form-group">
                                    <label htmlFor="totalVentas" className="control-label col-form-label">Total <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="totalVentas"
                                        id="totalVentas"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        {...registerModal("totalVentas", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.totalVentas && errorsModal.totalVentas.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="button" className="btn btn-sm btn-success waves-effect" onClick={saveData}>
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default VentasModal;
